import MainActions from '../../../../components/buybox/actions/actions-buybox';
import mainActions from './main-actions';

export default mainActions(MainActions);
